import { render, staticRenderFns } from "./DocumentAuditRemarks.vue?vue&type=template&id=4f4db263&"
import script from "./DocumentAuditRemarks.vue?vue&type=script&lang=js&"
export * from "./DocumentAuditRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QInput} from 'quasar'
component.options.components = Object.assign({QItem,QInput}, component.options.components || {})
